/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, useEffect, useMemo } from 'react';
import useSessionTagsSelector from '@hooks/session-tags/useSessionTagsSelector';
import {
    Autocomplete,
    FormControl,
    SelectChangeEvent, TextField,
} from '@mui/material';
import { SessionTagDto } from '@services/scanApi';

interface ScanTagFilterComponentProps {
    onChange: (event: SelectChangeEvent<string[]> | { target: { name: string, value: any } }) => void,
    value: string
}

const SessionTagFilterComponent: FC<ScanTagFilterComponentProps> = ({ value, onChange }) => {
    const {
        selectedTagObjects,
        allAvailableTags,
        handleTagChange,
        getOptionLabel,
        isLoadingTags,
        setInitialTags,
    } = useSessionTagsSelector();
    const initialTagIds = useMemo(() => value?.split(',').filter(Boolean) || [], [value]);

    useEffect(() => {
        if (setInitialTags && initialTagIds.length > 0) {
            setInitialTags(initialTagIds);
        }
    }, [setInitialTags, initialTagIds]);

    const handleAutocompleteChange = (event: any, newValue: SessionTagDto[] | null) => {
        handleTagChange(event, newValue);
        const tagIds = (newValue || [])
            .map((tag) => tag.id?.toString())
            .filter(Boolean);
        // Call the parent onChange with the expected format
        onChange({
            target: {
                name: 'sessionTags',
                value: tagIds.join(','),
            },
        });
    };

    return (
        <FormControl fullWidth disabled={isLoadingTags}>
            <Autocomplete
                multiple
                disableClearable
                disableListWrap
                size="small"
                options={allAvailableTags}
                value={selectedTagObjects}
                limitTags={1}
                onChange={handleAutocompleteChange}
                getOptionLabel={getOptionLabel}
                loading={isLoadingTags}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Session Tags"
                        variant="outlined"
                        multiline={false}
                    />
                )}
            />
        </FormControl>
    );
};

export default SessionTagFilterComponent;
